import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useUpdateCustomer } from "@/graphql/customer/update.customer";
import CustomerForm from "@/components/customer/CustomerForm.vue";
import { Customer } from "@/graphql/types";
import { useCustomerPermissions } from "@/hooks/permissions/useCustomerPermission";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerUpdate',
  props: {
    customer: {},
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { canUpdate } = useCustomerPermissions();
const { form, loading, updateCustomer, resetFields } = useUpdateCustomer(
  props.customer,
  () => emit("update:modelValue", false)
);
const cannotUpdate = computed(() => !canUpdate || loading.value);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    visible: _ctx.modelValue,
    header: _ctx.$t('update.title')
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(resetFields)())),
        class: "p-button-warning",
        icon: "pi pi-times",
        label: _ctx.$t('reset')
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "p-mt-2 p-button-outlined",
        type: "submit",
        icon: "pi pi-save",
        disabled: cannotUpdate.value,
        loading: _unref(loading),
        onClick: _unref(updateCustomer),
        label: _ctx.$t('save')
      }, null, 8, ["disabled", "loading", "onClick", "label"])
    ]),
    default: _withCtx(() => [
      _createVNode(CustomerForm, {
        name: _unref(form).name.$value,
        "onUpdate:name": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name.$value) = $event)),
        error: _unref(form).name.$hasError,
        phone: _unref(form).phone.$value,
        "onUpdate:phone": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).phone.$value) = $event)),
        "phone-error": _unref(form).phone.$hasError,
        address: _unref(form).address.$value,
        "onUpdate:address": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).address.$value) = $event)),
        email: _unref(form).email.$value,
        "onUpdate:email": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).email.$value) = $event)),
        errorEmail: _unref(form).email.$hasError,
        onSubmit: _withModifiers(_unref(updateCustomer), ["prevent"])
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_Button, { type: "submit" }, null, 512), [
            [_vShow, false]
          ])
        ]),
        _: 1
      }, 8, ["name", "error", "phone", "phone-error", "address", "email", "errorEmail", "onSubmit"])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})